module.exports = __webpack_public_path__ + "img/certificate_background.fe5139ed.jpg";